import type { ApiResponse } from '@api/types/api-response';
import { CSRF_TOKEN } from '@api/constants/cookies';
import { ROUTE as SESSION_IN_ROUTE } from '@api/routes/auth/session-in/params';
import { ROUTE as AUTH_ROUTE, Params as AuthParams } from '@api/routes/auth/user/sign-in/params';
import { SignInSignUpResult as AuthResult } from '@api/routes/auth/user/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { inMemoryPersistence, signInWithCustomToken } from 'firebase/auth';
import cookies from 'js-cookie';
import { auth } from 'src/firebase/client-app';
import { api } from 'src/utils/api';

export const signIn = createAsyncThunk<ApiResponse<AuthResult>, AuthParams, { rejectValue: string }>(
  'user/signIn',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      await auth.setPersistence(inMemoryPersistence);
      const idToken = await auth.currentUser?.getIdToken(/* forceRefresh */ true);
      const response = await api.sendRequest<AuthResult>({
        url: AUTH_ROUTE,
        method: 'POST',
        data: { ...data, idToken },
      });

      if (response.success) {
        await signInWithCustomToken(auth, response.data.token);

        const csrfToken = cookies.get(CSRF_TOKEN);

        if (idToken && csrfToken) {
          await api.sendRequest({ url: SESSION_IN_ROUTE, method: 'POST', data: { idToken, csrfToken } });

          return response;
        }
      } else {
        throw new Error(response.error.message as string);
      }
      throw new Error('SignInError');
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }
  }
);
